module.exports = __webpack_public_path__ + "img/mp.3680ccd9.svg";